import styled from 'styled-components';

export const Well = styled.div`
  background-color: ${({ theme }) => theme.colors.SNOW_500};
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-radius: 6px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.INK_600};

  svg {
    fill: ${({ theme }) => theme.colors.GREEN_600};
  }
`;
